import { Loader2 } from "lucide-react";
import { cn } from "../utils/cx.js";

export function Spin({ className }: { className?: string }) {
  return (
    <span
      className={cn("inline-flex items-center justify-center text-primary", className)}
      role="status"
      aria-label="Yükleniyor"
    >
      <Loader2 className="size-5 animate-spin" />
    </span>
  );
}
